// extracted by mini-css-extract-plugin
export default {"blockquote":"ContentEditor_blockquote__L3cgv","codeBlock":"ContentEditor_codeBlock__cculq"};